import { useIsCompactPlatformBar } from '@/hooks/useIsBreakpoint';
import { Button, forwardRef, Icon } from '@/ui';
import { VIEW_KEY_ROW_ID } from './viewKeyRowId';

type Props = {
  isOpen: boolean;
  onToggle: () => void;
};

// Opens the Key row docked under the platform bar, collapsing to the icon alone
// once the bar is crowded — matching EventFilter. Palette is the categories icon
// throughout the planner, so this and the Filter popover read as a pair.
//
// Takes a ref because closing the row unmounts the element focus was on, and the
// bar hands focus back here.
export const ViewKeyToggle = forwardRef<Props, 'button'>(
  ({ isOpen, onToggle }, ref) => {
    const isCompact = useIsCompactPlatformBar();

    const disclosureProps = {
      'aria-controls': VIEW_KEY_ROW_ID,
      'aria-expanded': isOpen,
    };

    if (isCompact) {
      return (
        <Button
          {...disclosureProps}
          aria-label="Key"
          isActive={isOpen}
          px="0"
          ref={ref}
          size="ah"
          variant="ahSecondary"
          w="var(--chakra-sizes-10)"
          onClick={onToggle}
        >
          <Icon icon="Palette" size={4} />
        </Button>
      );
    }

    return (
      <Button
        {...disclosureProps}
        isActive={isOpen}
        leftIcon={<Icon icon="Palette" size={4} />}
        ref={ref}
        size="ah"
        variant="ahSecondary"
        onClick={onToggle}
      >
        Key
      </Button>
    );
  }
);
